import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/login')
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('../views/index')
    },
    {
      path: '/history',
      name: 'history',
      component: () => import('../views/history')
    },
    {
      path: '/iviclouduse',
      name: 'iviclouduse',
      component: () => import('../views/iviclouduse')
    },
    {
      path: '/websiteuse',
      name: 'websiteuse',
      component: () => import('../views/websiteuse')
    },
    {
      path: '*',
      redirect: '/login'
    }
  ]
})
// 全局导航守卫 --- 登录拦截
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/websiteuse') {
    next()
    return
  }
  if (sessionStorage.getItem('userInfo')) {
    next()
    return
  }
  next('/login')
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js